<template>
  <v-card flat :height="height">
    <v-flex layout align-center justify-center pt-2 pb-3>
      <v-btn color="primary" small @click="loadPictures">
        {{ $t('statsMissionCard.displayGallery') }}
      </v-btn>
    </v-flex>
    <v-layout row justify-center>
      <v-dialog
        v-model="isDialogOpen"
        width="70%"
        style="background-color: white; !important"
      >
        <v-card class="theme--light" height="80%">
          <v-card-text>
            <v-layout wrap>
              <v-flex
                v-for="(pictureUrl, index) in observationPictures.slice(
                  0,
                  picturesToShow
                )"
                :key="index"
              >
                <a :href="pictureUrl" target="_blank">
                  <v-img class="galerieImg" height="250" :src="pictureUrl">
                  </v-img>
                </a>
              </v-flex>
            </v-layout>

            <div layout align-center justify-center>
              <!-- limite nbre de photos -->
              <v-chip
                v-if="picturesToShow < observationPictures.length"
                style="margin-left: 44%"
                @click="picturesToShow += 4"
              >
                {{ $t('confirmDialog.showMore') }}
              </v-chip>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">
              {{ $t('confirmDialog.close') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              outline
              right
              color="primary"
              class="text-none"
              @click="reload"
            >
              {{ $t('confirmDialog.reload') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-card>
</template>

<script>
import StatsBarChart from './StatsBarChart';
import StatsPieChart from './StatsPieChart';

export default {
  // camel case not kebab case
  name: 'stats-pictures',
  components: {
    StatsBarChart,
    StatsPieChart,
  },
  props: {
    gameId: {
      type: String,
      default: null,
    },
    datasets: {
      required: false,
      default: null,
    },
    labels: {
      required: false,
      default: null,
    },
    graphType: {
      required: false,
      default: null,
    },
    height: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      isDialogOpen: false,
      picturesToShow: 8,
      observationPictures: [],
      observationLoaded: false,
    };
  },
  created() {
    this.observationPictures = this.datasets;
  },
  methods: {
    resizeDate(date) {
      let decoupe = date.split('-');
      let newDate = decoupe[2] + ' / ' + decoupe[1];
      return newDate;
    },
    closeDialog() {
      this.isDialogOpen = false;
      this.picturesToShow = 8;
    },
    async reload() {
      this.observationLoaded = false;
      this.observationPictures = this.datasets || [];
      await this.loadPictures();
    },
    async loadPictures() {
      this.isDialogOpen = true;
      if (this.observationLoaded) return;
      try {
        const res = await this.$kuzzle.query({
          controller: 'picture',
          action: 'getObservations',
          gameId: this.gameId,
        });
        this.observationPictures = this.observationPictures
          .concat(res.result)
          .flat();
        this.observationLoaded = true;
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
.galerieImg {
  margin: 15px;
  height: 160px;
  width: 180px;
}
</style>
